import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fd978b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "triggers-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Nome", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Criado em:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Modificado em:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ativo", -1))
const _hoisted_7 = { class: "trigger-main" }
const _hoisted_8 = { class: "field name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Nome", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "field description" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Descrição", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "type" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Tipo", -1))
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "list-rules" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Regras", -1))
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Ações", -1))
const _hoisted_21 = { class: "checkbox" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviar Mensagem", -1))
const _hoisted_23 = { class: "checkbox" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mostrar Alarme", -1))
const _hoisted_25 = { class: "message-area" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Mensagem", -1))
const _hoisted_27 = {
  key: 0,
  class: "field"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Para", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Texto", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_TriggerCard = _resolveComponent("TriggerCard")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RuleCard = _resolveComponent("RuleCard")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleBar, { title: "Configurações de Alarmes" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageHeader, null, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.triggers, (trigger) => {
        return (_openBlock(), _createBlock(_component_TriggerCard, {
          key: trigger.id,
          trigger: trigger,
          onOnTriggerClick: _ctx.showTriggerDetails,
          onOnTriggerActivate: _ctx.editTrigger
        }, null, 8, ["trigger", "onOnTriggerClick", "onOnTriggerActivate"]))
      }), 128))
    ]),
    _createVNode(_component_Modal, {
      title: "Gatilho",
      isActive: _ctx.selectedTrigger != undefined,
      onCloseModalClick: _ctx.closeTriggerDetails,
      size: "large"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-bell" })
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("input", {
              type: "text",
              class: "input",
              value: _ctx.selectedTrigger?.name,
              readonly: ""
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("textarea", {
              value: _ctx.selectedTrigger?.description,
              class: "textarea",
              rows: "5",
              readonly: ""
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["icon", { alarm: _ctx.selectedTrigger?.type == 'alarm', warning: _ctx.selectedTrigger?.type == 'warning' }])
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-exclamation-triangle" })
              ], 2),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.selectedTrigger?.type == 'alarm' ? 'Alarme' : 'Advertência'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTrigger?.rules, (rule, index) => {
                return (_openBlock(), _createBlock(_component_RuleCard, {
                  key: index,
                  rule: rule
                }, null, 8, ["rule"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_21, [
                _createVNode(_component_CheckBox, {
                  checked: _ctx.selectedTrigger?.actions.includes('send_message')
                }, null, 8, ["checked"]),
                _hoisted_22
              ]),
              _createElementVNode("label", _hoisted_23, [
                _createVNode(_component_CheckBox, {
                  checked: _ctx.selectedTrigger?.actions.includes('show')
                }, null, 8, ["checked"]),
                _hoisted_24
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", null, [
              (_ctx.selectedTrigger?.actions.includes('send_message'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("input", {
                      type: "text",
                      class: "input",
                      value: _ctx.sendTo,
                      readonly: ""
                    }, null, 8, _hoisted_29)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("textarea", {
                  class: "textarea",
                  value: _ctx.selectedTrigger?.message,
                  rows: "3"
                }, null, 8, _hoisted_32)
              ])
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeTriggerDetails && _ctx.closeTriggerDetails(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "button edit-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editTrigger(_ctx.selectedTrigger)))
          }, "Editar")
        ])
      ]),
      _: 1
    }, 8, ["isActive", "onCloseModalClick"])
  ], 64))
}